import React from 'react';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Clausura2012 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 710; i <= 732; i++) {
           if([716,719,721,722,727,728].indexOf(i) === -1){
        	id_list.push(i);
	    }
        }
    this.state = {
	showCards: true,
kit_path: '/images/kits/todas/',
      kits: [],
      path: this.props.path,
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,

	table2:[{'color':0,'shortname':'cobreloa', 'rivalName':'Cobreloa', 'pj':17, 'pg':6,'pe':2,'pp':9,'gf':23,'gc':24,'dif':-1, 'pts':20},
              {'color':'#295e1e','shortname':'audax', 'rivalName':'Audax Italiano', 'pj':17, 'pg':6,'pe':5,'pp':6,'gf':29,'gc':26,'dif':3, 'pts':23},
              {'color':0,'shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':17, 'pg':4,'pe':7,'pp':6,'gf':27,'gc':28,'dif':-1, 'pts':19},
	      {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':17, 'pg':3,'pe':6,'pp':8,'gf':17,'gc':28,'dif':-11, 'pts':15},
              {'color':0,'shortname':'catolica', 'rivalName':'U. Católica', 'pj':17, 'pg':6,'pe':5,'pp':6,'gf':24,'gc':23,'dif':1, 'pts':23},
              {'color':'#135683','shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':17, 'pg':9,'pe':6,'pp':2,'gf':32,'gc':14,'dif':18, 'pts':33},
              {'color':0,'shortname':'cobresal', 'rivalName':'Cobresal', 'pj':17, 'pg':5,'pe':7,'pp':5,'gf':22,'gc':24,'dif':-2, 'pts':22},
              {'color':'#295e1e','shortname':'huachipato', 'rivalName':'Huachipato', 'pj':17, 'pg':7,'pe':4,'pp':6,'gf':23,'gc':21,'dif':2, 'pts':25},
              {'color':'#295e1e','shortname':'udechile', 'rivalName':'U. de Chile', 'pj':17, 'pg':9,'pe':6,'pp':2,'gf':32,'gc':20,'dif':12, 'pts':33},
              {'color':0,'shortname':'lacalera', 'rivalName':'U. La Calera', 'pj':17, 'pg':2,'pe':9,'pp':6,'gf':11,'gc':18,'dif':-7, 'pts':15},
              {'color':'#295e1e','shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':17, 'pg':9,'pe':3,'pp':5,'gf':24,'gc':27,'dif':-3, 'pts':30},
              {'color':'#295e1e','shortname':'union', 'rivalName':'U. Española', 'pj':17, 'pg':7,'pe':3,'pp':7,'gf':28,'gc':28,'dif':0, 'pts':24},
              {'color':'#295e1e','shortname':'rangers', 'rivalName':'Rangers', 'pj':17, 'pg':8,'pe':6,'pp':3,'gf':27,'gc':19,'dif':8, 'pts':30},
	      {'color':0,'shortname':'laserena', 'rivalName':'La Serena', 'pj':17, 'pg':2,'pe':6,'pp':9,'gf':20,'gc':33,'dif':-13, 'pts':12},
	      {'color':0,'shortname':'sanfelipe', 'rivalName':'U. San Felipe', 'pj':17, 'pg':6,'pe':3,'pp':8,'gf':19,'gc':21,'dif':-2, 'pts':21},
              {'color':'#295e1e','shortname':'palestino', 'rivalName':'Palestino', 'pj':17, 'pg':9,'pe':3,'pp':5,'gf':22,'gc':18,'dif':4, 'pts':30},
              {'color':0,'shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':17, 'pg':5,'pe':5,'pp':7,'gf':22,'gc':27,'dif':-5, 'pts':20},
              {'color':0,'shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':17, 'pg':6,'pe':2,'pp':9,'gf':26,'gc':29,'dif':-3, 'pts':20}],

        table3:[{'color':0,'shortname':'cobreloa', 'rivalName':'Cobreloa', 'pj':34, 'pg':13,'pe':4,'pp':17,'gf':46,'gc':49,'dif':-3, 'pts':43},
              {'color':0,'shortname':'audax', 'rivalName':'Audax Italiano', 'pj':34, 'pg':11,'pe':10,'pp':13,'gf':53,'gc':58,'dif':-5, 'pts':43},
              {'color':'#E42727','shortname':'sanfelipe', 'rivalName':'U. San Felipe', 'pj':34, 'pg':8,'pe':10,'pp':16,'gf':31,'gc':42,'dif':-11, 'pts':34},
              {'color':'#E4AB27','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':34, 'pg':8,'pe':12,'pp':14,'gf':40,'gc':55,'dif':-15, 'pts':36},
              {'color':0,'shortname':'catolica', 'rivalName':'U. Católica', 'pj':34, 'pg':14,'pe':11,'pp':9,'gf':55,'gc':40,'dif':15, 'pts':53},
              {'color':0,'shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':34, 'pg':16,'pe':11,'pp':7,'gf':54,'gc':35,'dif':19, 'pts':59},
              {'color':'#E4AB27','shortname':'cobresal', 'rivalName':'Cobresal', 'pj':34, 'pg':7,'pe':12,'pp':15,'gf':39,'gc':64,'dif':-25, 'pts':35},
              {'color':0,'shortname':'huachipato', 'rivalName':'Huachipato', 'pj':34, 'pg':13,'pe':9,'pp':12,'gf':48,'gc':49,'dif':-1, 'pts':48},
              {'color':0,'shortname':'udechile', 'rivalName':'U. de Chile', 'pj':34, 'pg':22,'pe':7,'pp':5,'gf':76,'gc':34,'dif':42, 'pts':73},
              {'color':0,'shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':34, 'pg':10,'pe':9,'pp':15,'gf':55,'gc':58,'dif':-3, 'pts':39},
              {'color':'#135683','shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':34, 'pg':19,'pe':8,'pp':7,'gf':54,'gc':41,'dif':13, 'pts':65},
              {'color':0,'shortname':'union', 'rivalName':'U. Española', 'pj':34, 'pg':15,'pe':6,'pp':13,'gf':66,'gc':56,'dif':10, 'pts':51},
              {'color':0,'shortname':'rangers', 'rivalName':'Rangers', 'pj':34, 'pg':13,'pe':9,'pp':12,'gf':44,'gc':44,'dif':0, 'pts':48},
              {'color':'#E42727','shortname':'laserena', 'rivalName':'La Serena', 'pj':34, 'pg':7,'pe':10,'pp':17,'gf':44,'gc':66,'dif':-22, 'pts':31},
              {'color':0,'shortname':'lacalera', 'rivalName':'U. La Calera', 'pj':34, 'pg':8,'pe':15,'pp':11,'gf':32,'gc':36,'dif':-4, 'pts':39},
              {'color':0,'shortname':'palestino', 'rivalName':'Palestino', 'pj':34, 'pg':14,'pe':6,'pp':14,'gf':36,'gc':44,'dif':-8, 'pts':48},
              {'color':0,'shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':34, 'pg':16,'pe':7,'pp':11,'gf':53,'gc':42,'dif':11, 'pts':55},
              {'color':0,'shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':34, 'pg':10,'pe':7,'pp':17,'gf':36,'gc':49,'dif':-13, 'pts':37}]

    };
  }

  componentDidMount() {
	this.getKits();
		let newtable = this.sortTable(this.state.table2);
  		this.setState({table2:newtable});
		let newtable2 = this.sortTable(this.state.table3);
                this.setState({table3:newtable2});
	}

getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", socks:"blue", count:15, 
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}


  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={3} xl={3} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color} style={{width:'20px'}}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].pg < table[j+1].pg)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].pg === table[j+1].pg) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].pg === table[j+1].pg) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
                        aux = table[j+1];
                        table[j+1] = table[j];
                        table[j] = aux;
                } 
             }          
        }
return table;

}



render(){


  let subT = this.subText('#295e1e', 'Clasificado a Play-Off');
  let subC = this.subText('#135683', 'Clasificado a Play-Off y a Sudamericana 2013');
    let subP = this.subText('#E4AB27', 'Juega Liguilla Promoción');
  let subD = this.subText('#E42727', 'Desciende a Primera B');
let subL = this.subText('#135683', 'Clasificado a Libertadores 2013');
  return(

	<div style={{textAlign: 'center' }}>
	         <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Clausura 2012</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>


	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}

	<div style={{ height: '10px' }}></div>
	{subC}
	{subT}
	
	<div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos"> Tabla Anual 2012</div>
        <div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table3} />}

        <div style={{ height: '10px' }}></div>
        {subL}
        {subP}
 	{subD}


	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Clausura 2012</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Clausura 2012</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Clausura 2012" />
     </div>


  )
}

}
export default Clausura2012;
